<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-on:submit.prevent="submitForm">
        <v-container>
          <v-row>
            This account has been temporarily blocked due to payment issues. If you believe this to be an error please contact <a href="mailto:accounts@tubeway.io">accounts@tubeway.io</a>.
          </v-row>

          <v-row v-if="$canControlTenantConfig()">
            You can manage your subscription in our partner's website:
          </v-row>

          <v-row v-if="$canControlTenantConfig()">
            <v-btn
                v-bind:href="stripeurl"
                v-bind:disabled="!stripeurl"
                target="_blank"
                color="secondary"
                block
                data-cy=""
              >

              Go to website
              <v-icon size="small">mdi-arrow-top-right-bold-box-outline</v-icon>
            </v-btn>

            <div v-if="errorMessage" class="bg-error" data-cy="">
              {{errorMessage}}
            </div>
          </v-row>

          <v-row class="mt-5">
            <v-btn type="button" v-on:click="logout" class="bg-primary" block>Logout</v-btn>
          </v-row>
        </v-container>
      </v-form>

    </div>
  </div>
</template>

<script>
import { useSystemStore } from '@/stores/SystemStore.js'
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: "TenantExpired",
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      stripeurl: null,
      errorMessage: '',
    };
  },
  mounted: function() {
    if (this.$canControlTenantConfig()) {
      this.getStripeURL();
    }
  },
  methods: {
    submitForm: function() {
      console.log("submit form")
    },
    logout: function() {
      this.$router.push('/account/logout');
    },
    getStripeURL: function() {
      //get the portal url
      let self = this;
      const systemStore = useSystemStore();
      systemStore.manageSubscriptionUrl()
      .then(function(response) {
        if (response && response.data && response.data.url) {
          self.stripeurl = response.data.url;
        }
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          self.errorMessage = error.response.data.error.message;
        } else {
          self.errorMessage = "Error!";
        }
      });
    },
  },
  computed: {
  }
}
</script>
